import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  MEDIUM_DEVICE_MQ,
  SMALL_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const sidenavClassName = css({
  alignItems: 'stretch',
  display: 'none',
  flex: '0 0 auto',
  height: 'calc(100% - 68px)',
  position: 'fixed',
  top: 68,
  width: '100%',
  zIndex: 999,
  [MEDIUM_DEVICE_MQ]: {
    display: 'flex',
    width: 'auto',
  },
});

export const visibleClassName = css({
  display: 'flex',
});

export const innerClassName = css({
  background: Colors.White,
  borderRight: '1px solid #DDD',
  height: '100%',
  minHeight: '100%',
  overflow: 'auto',
  width: '100%',
  [MEDIUM_DEVICE_MQ]: {
    width: 250,
  },
});

export const headerClassName = css({
  padding: `${Spacing.XL}px ${Spacing.LG}px`,
});

export const primaryButtonClassName = css({
  background: Colors.Primary,
  color: Colors.White,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.BOLD,
  '&:hover': {
    background: Colors.PrimaryHover,
  },
});

export const bodyClassName = css({
  marginTop: Spacing.MD,
});

export const sidenavListClassName = css({
  display: 'flex',
  flexDirection: 'column',
});

export const sidenavItemClassName = css({
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  margin: `${Spacing.MD}px 0`,
  padding: `${Spacing['2XS']}px ${Spacing.LG}px`,
  '&:hover': {
    borderRight: `4px solid ${Colors.Brand}`,
  },
  '&:first-child': {
    marginTop: 0,
  },
  [SMALL_DEVICE_MQ]: {
    margin: `${Spacing.SM}px 0`,
  },
});

export const activeClassName = css({
  borderRight: `4px solid ${Colors.Brand}`,
});

export const iconClassName = css({
  color: Colors.Secondary,
  height: 20,
  width: 20,
  [SMALL_DEVICE_MQ]: {
    height: 18,
    width: 18,
  },
});

export const activeIconClassName = css({
  color: Colors.Brand,
});

export const labelClassName = css({
  color: Colors.Primary,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.SEMI_BOLD,
  marginLeft: 20,
  [SMALL_DEVICE_MQ]: {
    fontWeight: FontWeight.MEDIUM,
    marginLeft: Spacing.MD,
  },
});
